import BaseComponent from '../base_component/base_component';

export default class RoadshowSlots extends BaseComponent {
    initialize() {
        this.openFirstSection();
        $(this.component).find('.panel-heading').click((e) => {
            $('.collapse').collapse('hide');
            let accordion = $(e.target).closest('.panel-heading').find('.fa.accordion');
            if ($(e.target).closest('.panel-default').find('.panel-body.in').length === 0) {
                accordion.removeClass('fa-angle-down');
                accordion.addClass('fa-angle-up');
            } else {
                accordion.addClass('fa-angle-down');
                accordion.removeClass('fa-angle-up');
            }
        });
    }

    openFirstSection() {
        $('.panel-default').children()[0].click()
    }
}